<template>
    <div class="block-editor filter">
        <div v-for="(group, index) of clone.groups" :key="group.id">
            <FilterGroup
                :on-removed="onFilterGroupRemoved"
                v-model="clone.groups[index]"
                :show-remove-button="clone.groups.length > 1"
                :automation="automation"
            />
            <div class="filter-condition-wrapper" v-if="clone.groups.length > 1 && index !== clone.groups.length - 1">
                <div class="filter-condition">
                    <a-select
                        :value="clone.operator"
                        @change="(op) => (clone.operator = op)"
                        @click="
                            (e) => {
                                e.stopPropagation();
                            }
                        "
                        @mouseenter="() => (selectHovered = true)"
                        @mouseleave="() => (selectHovered = false)"
                        :class="{ hovered: selectHovered }"
                    >
                        <a-select-option value="or">{{ $t("chatbotv2.or") }}</a-select-option>
                        <a-select-option value="and"> {{ $t("chatbotv2.and") }}</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>

        <div class="filter-add-group-wrapper">
            <div class="filter-add-group" @click="addFilterGroup">
                <div class="filter-add-group-plus">
                    <span class="material-icons"> add </span>
                </div>
                <span>{{ $t("chatbotv2.addFilterGroup") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import FilterGroup from "./FilterGroup";
import log2 from "../../../../../../../utils/log2";
import { generateRandomId } from "../../../../../../../utils/session";

const log = log2("FilterBlock");
export default {
    name: "FilterBlock",
    components: { FilterGroup },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                groups: [],
                operator: "or",
            }),
        },
        automation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            filterAddCtx: null,
            selectHovered: false,
        };
    },
    methods: {
        onFilterGroupRemoved(id) {
            this.clone.groups = this.clone.groups.filter((group) => group.id !== id);
        },
        addFilterGroup() {
            const id = generateRandomId();
            this.clone.groups.push({
                id,
                operator: "or",
                filters: [],
            });
        },
    },
    mounted() {
        log("mounted", this.value);
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.filter {
    grid-row-gap: 20px;
    display: grid;
    padding: 30px 0 60px;

    .filter-condition-wrapper {
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        &:before {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        &:after {
            border-top: 1px solid #ccc;
            content: "";
            flex-grow: 1;
            height: 0;
            width: 0;
        }

        .filter-condition {
            margin: 0px 25px;
            width: 80px;

            .ant-select {
                &.hovered {
                    .ant-select-selection {
                        border-color: #40a9ff !important;
                        border-right-width: 1px !important;
                        background: #40a9ff52 !important;
                    }
                }
            }
        }
    }
}

.filter-add-group-wrapper {
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 100%;

    &:before {
        border-top: 1px solid #ccc;
        content: "";
        flex-grow: 1;
        height: 0;
        width: 0;
    }

    &:after {
        border-top: 1px solid #ccc;
        content: "";
        flex-grow: 1;
        height: 0;
        width: 0;
    }

    .filter-add-group {
        cursor: pointer;
        display: flex;
        margin: 0 10px;
        transition: opacity 0.3s;

        span {
            color: #475e7a;
            font-weight: 600;
        }

        .filter-add-group-plus {
            align-items: center;
            background: #fff;
            border-radius: 100%;
            box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
            display: flex;
            height: 22px;
            justify-content: center;
            margin-right: 10px;
            transition: background-color 0.3s;
            width: 22px;

            &:hover {
                background: #006cff;
                color: #fff;

                .material-icons {
                    color: #fff;
                }
            }

            .material-icons {
                color: #006cff;
                font-size: 12px;
                margin-left: 1px;
                transition: color 0.6s;
            }
        }
    }
}
</style>
